import * as Util from '../util/utilities';
import datepickerFactory from 'jquery-datepicker';

export default {
    init() {},
    finalize() {

        // State
        let type_set = false;
        let radius_set = false;
        let location_set = false;

        // If Spruce has a usable store, update this function's state
        if(
            (typeof Spruce.store('search').latitude === 'number' && 
            typeof Spruce.store('search').longitude === 'number' &&
            typeof Spruce.store('search').radius === 'number' &&
            Spruce.store('search').location_type === 'Physical') ||
            Spruce.store('search').location_type === 'Online'
        ) {
            type_set = radius_set = location_set = true;
        }

        let latest_google_query = '';

        /// Proximity up and down

        $('#radius_plus').click(ev => {
            ev.preventDefault();
            var seats = $('#radius').val();
            var seats = parseInt(seats) + 10;
            //$('#radius').val(seats);
            Spruce.store('search').radius = seats;
        });

        $('#radius_minus').click(ev => {
            ev.preventDefault();
            var seats = $('#radius').val();
            var seats = parseInt(seats) - 10;
            //$('#radius').val(seats);
            Spruce.store('search').radius = seats;
        });

        // Toggle between the summary view and primary filter inputting views

        let toggle_summaries = function(target) {
            jQuery('#find-summaries').hide();
            if (typeof target === 'object') {
                var summary = jQuery(this).data('fieldset');
            } else {
                var summary = target;
            }
            jQuery(`#${summary}`).show();
        };

        $('.find-summary').on('click', toggle_summaries);

        // Generate the summary text and inject it into the HTML

        let summary_text = () => {

            jQuery('#find-form > fieldset').hide();

            if (!location_set) {
                jQuery('.find-summary[data-fieldset="group_type"]').text('Select Group Type');
                jQuery('.find-summary[data-fieldset="location_range"]').text('Enter a Range');
                jQuery('.find-summary[data-fieldset="enter_location"]').text('Enter Your Zip');
            } else {
                let group_type = ' Groups';
                let location_type = jQuery('input[name="location_type"]:checked').val();
                if (location_type == 'Physical') {
                    group_type = `In Person${group_type}`;
                } else {
                    group_type = `Online${group_type}`;
                }

                jQuery('.find-summary[data-fieldset="group_type"]').text(group_type);

                if (location_type == 'Physical') {
                    let location_range = 'Within ';
                    location_range += jQuery('input[name="radius"]').val();
                    location_range += ' miles of';

                    let enter_location = jQuery('#find-location').val();

                    jQuery('.find-summary[data-fieldset="location_range"]').text(location_range);
                    jQuery('.find-summary[data-fieldset="enter_location"]').text(enter_location);
                } else {
                    jQuery('.find-summary[data-fieldset="location_range"]').text('Range not applicable');
                    jQuery('.find-summary[data-fieldset="enter_location"]').text('Location not applicable');
                }
            }

            jQuery('#find-summaries').show();
        };

        // Update state booleans

        let update_state_booleans = function() {
            const btn_id = jQuery(this).attr('id');
            switch (btn_id) {
                case 'find-save-type':
                    type_set = true;
                    break;
                case 'find-save-radius':
                    radius_set = true;
                    break;
                case 'find-save-location':
                    location_set = true;
                    break;
            }
        };

        jQuery('.find-save').on('click', update_state_booleans);

        // Reset paginations when params change

        let reset_pagination = () => {
            //jQuery('input[name="page_num"]').val(1);
            Spruce.store('search').page_num = 1;
        };

        jQuery('.find-save').on('click', reset_pagination);

        // The power function – submit the query via AJAX

        let submit_query = ev => {

            summary_text();

            if (typeof ev === 'object') {
                ev.preventDefault();
                ev.stopPropagation();
            }

            if (jQuery('input[name="location_type"]:checked').val() == 'Physical') {
                jQuery('#find-online-bg').fadeOut();

                // This occurs if someone starts with online then moves to a physical search
                if (jQuery('#find-location').val() == '') {
                    toggle_summaries('enter_location');
                    return;
                }

                if (typeof window.findMap === 'object') {
                    if (location_set) {
                        let lat = parseFloat(jQuery('input[name="latitude"]').val());
                        let lng = parseFloat(jQuery('input[name="longitude"]').val());
                        let lat_lng = { lat, lng };
                        let zoom = 8;
                        let radiusMiles = parseFloat(jQuery('input[name="radius"]').val());
                        // Zoom in
                        if (radiusMiles < 31) {
                            zoom = 9;
                        }
                        // Zoom out
                        if (radiusMiles > 399) {
                            zoom = 5;
                        } else if (radiusMiles > 159) {
                            zoom = 6;
                        } else if (radiusMiles > 109) {
                            zoom = 7;
                        }
                        if (window.findMapCircle !== null) {
                            window.findMapCircle.setMap(null);
                            window.findMapCircle = null;
                        }
                        window.findMapCircle = new google.maps.Circle({
                            fillColor: '#D99778',
                            fillOpacity: 0.2,
                            strokeWeight: 0,
                            map: window.findMap,
                            center: lat_lng,
                            radius: Util.milesToMeters(radiusMiles)
                        });
                        findMap.setCenter(lat_lng);
                        findMap.setZoom(zoom);
                    }
                }
            } else {
                jQuery('#find-online-bg').fadeIn();
            }

            if (!location_set) {
                return;
            }

            jQuery
                .ajax({
                    url: launchframe.ajax_url,
                    beforeSend() {
                        jQuery('#find-results').hide();
                        // jQuery('#find-filters').hide();
                        jQuery('#find-loading').show();
                    },
                    data: jQuery('#find-form').serialize(),
                    dataType: 'json'
                })
                .done(data => {

                    //console.debug(data);

                    // Serialize and push form to URL
                    let spruce_search_store_to_serialize = {};
                    for (const key in spruce_search_store_default) {
                        if(Spruce.store('search')[key] != spruce_search_store_default[key]) {
                            spruce_search_store_to_serialize[key] = Spruce.store('search')[key];
                        }
                    }
                    const qs = Object.keys(spruce_search_store_to_serialize)
                        .map(key => `${key}=${encodeURIComponent(spruce_search_store_to_serialize[key])}`)
                        .join('&');
                    history.pushState({}, '', '?' + qs);

                    // Inject HTML

                    jQuery('#find-loading').hide();
                    jQuery('#find-results').html('');
                    let count = data.total;
                    let plural = 'results';
                    if (count == 0) {
                        count = 'no';
                    } else if (count == 1) {
                        plural = 'result';
                    }

                    jQuery('html, body').animate({
                        scrollTop: jQuery('#results-container').offset().top - 128
                    });

                    jQuery('#find-results').append(
                        `<div class="text-3xl md:text-4xl mb-12 font-medium text-center">We found ${count} ${plural}:</div>`
                    );
                    for (let i = 0; i < data.results.length; i++) {
                        const options = { timeZone: 'UTC', year: 'numeric', month: 'short', day: 'numeric' };
                        var start_date = data.results[i].start_day;
                        var start_date = new Date(start_date);
                        var start_date = start_date.toLocaleDateString('en-US', options);
                        var end_date = data.results[i].end_day;
                        var end_date = new Date(end_date);
                        var end_date = end_date.toLocaleDateString('en-US', options);
                        var restrictions = data.results[i].restrictions;
                        if (jQuery.isEmptyObject(restrictions)) {
                            var restrictions = '';
                        } else {
                            var restrictions = '<span class="block text-charcoal-50">(Only)</span>';
                        }
                        var age_range = data.results[i].age_range;
                        if (jQuery.isEmptyObject(age_range)) {
                            age_range = restrictions = '';
                        } else {
                            age_range = ', ' + age_range;
                        }
                        var image = data.results[i].cover_image;
                        if (jQuery.isEmptyObject(image)) {
                            var image = '<div class="w-full h-48 lg:h-64 rounded-xs bg-fog-cta hidden md:block"></div>';
                        } else {
                            var image = `<img src='${data.results[i].cover_image}' alt='Study Cover' class='rounded-xs'>`;
                        }
                        var location = data.results[i].location_type;
                        if (location == 'Online') {
                            var location = 'Online';
                        } else {
                            var location = `${data.results[i].city}, ${data.results[i].state}`;
                        }
                        if (jQuery.isEmptyObject(data.results[i].bible_study_category2)) {
                            var cats = data.results[i].bible_study_category;
                        } else {
                            var cats = `${data.results[i].bible_study_category} with ${data.results[i].bible_study_category2}`;
                        }
                        if (data.results[i].level2 == '') {
                            var levels = `Level ${data.results[i].level}`;
                        } else {
                            var levels = `Levels ${data.results[i].level} and ${data.results[i].level2}`;
                        }
                        jQuery('#find-results').append(
                            `<div class='bg-white border-2 border-b-4 rounded-xs p-10 mb-4 single-group-result'><div class='md:flex items-center'><div class='md:w-7/12 lg:w-3/4 md:flex items-center'><div class='md:w-4/12 lg:w-1/2 md:pr-8 mb-4 md:mb-0 text-center md:text-left'><a href='/group/?id=${
                                data.results[i].group_id
                            }'>${image}</a></div><div class='md:w-8/12 lg:w-1/2 md:pr-8'><p class='text-charcoal-50'>${cats}<br>${levels}</p><h2 class='font-medium text-2xl md:text-3xl leading-tight mb-3'>${
                                data.results[i].bible_study_title
                            }</h2><p class='text-lg mb-3'>${Util.emptyIfNull(
                                data.results[i].description
                            )}</p><a class='font-medium text-ocean text-lg md:text-sm hover:text-charcoal' href='/group/?id=${
                                data.results[i].group_id
                            }'>View Group ⇢</a></div></div><div class='md:w-5/12 lg:w-1/4 md:border-l border-fog-cta pt-8 md:py-6 md:pl-8'><div class='flex items-center mb-6'><div class='group-icon-location'></div><div class='leading-tight'><p class='font-medium text-lg'>${location}</p></div></div><div class='flex items-center mb-6 text-sm'><div class='group-icon-time'></div><div class='leading-tight'><p>${
                                Util.emptyIfNull(data.results[i].day_of_week)
                            }</p><p><span class='lowercase'>${data.results[i].start_time} - ${
                                data.results[i].end_time
                            }</span> (${
                                data.results[i].timezone
                            })</p></div></div><div class='flex items-center mb-6 text-sm'><div class='group-icon-date'></div><div class='leading-tight'><p>${start_date} - ${end_date}</p></div></div><div class='flex items-center text-sm'><div class='group-icon-group'></div><div class='leading-tight'><p>${
                                data.results[i].primary_audience
                            }${age_range}${restrictions}</p></div></div></div></div></div>`
                        );
                    }

                    if (data.total == 0) {
                        jQuery('#find-results').append(
                            '<div class="my-12 text-2xl text-charcoal-50 font-medium text-center">Looks like there are no groups that match those details. Try adjusting the filters or location to show more results.</div>'
                        );
                    }

                    // jQuery('#find-results').append('Total Results: ' + data.total + '<br>');
                    // jQuery('#find-results').append('Total Pages: ' + data.total_pages + '<br>');
                    // jQuery('#find-results').append('Total Pages: ' + data.page);

                    // Map pins

                    clear_pins();

                    for (var i = 0; i < data.pins.length; i++) {
                        let markerLatlng = new google.maps.LatLng(data.pins[i].latitude, data.pins[i].longitude);

                        let marker = new google.maps.Marker({
                            position: markerLatlng,
                            animation: google.maps.Animation.DROP,
                            icon: `${launchframe.theme_url}/dist/images/map-group-pin.png`
                        });

                        // To add the marker to the map, call setMap();
                        marker.setMap(window.findMap);

                        window.findMapPins.push(marker);
                    }

                    let pagination = '';

                    for (var i = 1; i <= data.total_pages; i++) {
                        if (data.page == i) {
                            pagination += `<span aria-current='page' class='current'>${data.page}</span>`;
                        } else {
                            pagination += `<a class='page larger' title='Page ${i}' href='#page${i}'>${i}</a>`;
                        }
                    }

                    jQuery('#find-results').append(
                        `<div class='py-6 text-center'><div class='wp-pagenavi' role='navigation'>${pagination}</div></div>`
                    );
                    
                    jQuery('#find-filters').show();
                    jQuery('#find-results').show();

                    // Add functionality to the pagination HTML
                    jQuery('#find-results')
                        .find('.page.larger')
                        .on('click', function(ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                            //jQuery('input[name="page_num"]').val(parseInt(jQuery(this).html()));
                            Spruce.store('search').page_num = parseInt(jQuery(this).html());
                            submit_query();
                            jQuery('html, body').animate({
                                scrollTop: jQuery('#find-map').offset().top
                            });
                        });
                });
        };

        jQuery('.find-save').on('click', submit_query); // Submit the query every time a new filter is saved

        submit_query(); // Submit the query on page load

        let toggle_inperson_fields = () => {
            let val = jQuery('input[name="location_type"]:checked').val();
            if (val == 'Physical') {
                jQuery('#find-form').removeClass('is-online');
            } else {
                jQuery('#find-form').addClass('is-online');
            }
        };

        jQuery('.find-save').on('click', toggle_inperson_fields); // Adjust visible summaries based on online / in-person

        jQuery('#find-location').on( "keypress", function(ev) {
            if(ev.which == 13) {
                var to;
                var disabled_check = function() {
                    if($('#find-save-location').prop('disabled')) {
                        to = setTimeout(disabled_check, 250);   
                    } else {
                        jQuery('#find-save-location').click();
                    }
                }
                disabled_check();
            }
        });

        toggle_inperson_fields(); // Make sure this is right on page load

        // Geocode the location nformation provided

        let geocode_address = () => {
            // Setup variables

            let address = jQuery('#find-location').val();

            let callback = (results, status, original) => {
                if(original != latest_google_query) {
                    console.warn('Geocoding results came back out of order – ignoring this result');
                } else if (status == 'OK') {
                    let result = results[0];
                    let lat = result.geometry.location.lat();
                    let lng = result.geometry.location.lng();
                    console.debug(lat);
                    console.debug(lng);
                    //jQuery('input[name="latitude"]').val(lat);
                    //jQuery('input[name="longitude"]').val(lng);
                    Spruce.store('search').latitude = lat;
                    Spruce.store('search').longitude = lng;
                    $('#find-save-location').prop('disabled', false);
                } else {
                    console.warn(`Geocode was not successful for the following reason: ${status}`);
                }
            };

            if (address.length < 5) {
                // Wait until address input is completed to geocode
            } else {
                // Call Google Maps
                latest_google_query = address;
                $('#find-save-location').prop('disabled', true);
                if(address.length == 5 && !isNaN(address)) {
                    window.googleMapsZipGeocode(address, callback);
                } else {
                    window.googleMapsGeocode(address, callback);
                }
            }
        };

        jQuery('#find-location').on('input', geocode_address);

        // Locate me button

        let locateme = ev => {
            if (typeof ev === 'object') {
                ev.preventDefault();
                ev.stopPropagation();
            }

            let callback = (results, status) => {
                console.log(status);
                if (status == 'OK') {
                    let result = results[0];
                    let zip = window.findAddressComponentType(result.address_components, 'postal_code');
                    if (typeof zip === 'object') {
                        // jQuery('#find-location').val(zip.long_name);
                        Spruce.store('search').location = zip.long_name;
                        location_set = true;
                        submit_query();
                    }
                } else {
                    console.warn(`Reverse geocode was not successful for the following reason: ${status}`);
                }
            };

            let reverse_geocode = (lat, lng) => {
                window.googleMapsReverseGeocode(lat, lng, callback);
            };

            let savePosition = ({ coords }) => {
                //jQuery('input[name="latitude"]').val(coords.latitude);
                //jQuery('input[name="longitude"]').val(coords.longitude);
                Spruce.store('search').latitude = coords.latitude;
                Spruce.store('search').longitude = coords.longitude;
                reverse_geocode(coords.latitude, coords.longitude);
            };

            if (navigator.geolocation) {
                // savePosition({ coords: { latitude:35.0449767, longitude: -85.31620660000002 } });
                navigator.geolocation.getCurrentPosition(savePosition);
            }
        };

        jQuery('#find-locateme').on('click', locateme);

        // Online skip button

        let online_skip = ev => {

            if (typeof ev === 'object') {
                ev.preventDefault();
                ev.stopPropagation();
            }

            //jQuery('input[name="location_type"]').prop('checked', false);
            //jQuery('input[value="Online"]').prop('checked', true);
            Spruce.store('search').location_type = 'Online';

            toggle_inperson_fields();
            location_set = true;

            submit_query();

        };

        jQuery('#find-online').on('click', online_skip);

        // Mobile secondary filters

        var clicked_off_mobile_secondary = function(event) {
            if(!jQuery(event.target).closest('#find-filters').length){
                toggle_mobile_secondary();
                jQuery(this).off('click', toggle_mobile_secondary);
            }
        };

        var toggle_mobile_secondary = function() {
            jQuery('#find-filters-toggle').toggleClass('mb-4').siblings().toggleClass('hidden');
            jQuery('#find-filters-by img').toggleClass('is-mirrored');
            jQuery(document).on("click", clicked_off_mobile_secondary);
        };

        jQuery('#find-filters-toggle').on('click', toggle_mobile_secondary);

        jQuery('#mobile-seconary-save').on('click', function() {
            submit_query();
            // jQuery('#find-filters-toggle').click();
        }); 

        // Kick things off

        if(!location_set) {
            jQuery('#find-online-bg').fadeOut();
            toggle_summaries('enter_location');
        }

        datepickerFactory($);
        $('#group_starts').datepicker({
            dateFormat: 'yy-mm-dd',
            onClose: function(val) {
                window.Spruce.store('search').start_date = val;
            },
            beforeShow: function() {
                setTimeout(function(){
                    $('.ui-datepicker').css('z-index', 21);
                }, 50);
            }
        });

        // Helper function

        let clear_pins = () => {
            for (let i = 0; i < window.findMapPins.length; i++) {
                window.findMapPins[i].setMap(null);
                window.findMapPins[i] = null;
            }

            window.findMapPins = [];
        };

        window.setFilterValue = (field, value, quiet = false) => {
            jQuery('input[name="'+field+'"]').val(value);
            if(!quiet) {
                submit_query();
            }
        }

        window.setFilterFocus = (ref) => {
            setTimeout(function(){ jQuery(ref).focus(); }, 250);
        }

        window.setEmptyFilterFocus = (val, ref) => {
            if(val == '') {
                setFilterFocus(ref);
            }
        }

    }
};
